import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"currentColor\" id=\"icon-check\">\n  <path d=\"M14.125,5.312L8.5,10.938L5.875,8.312L4,10.188l4.5,4.5l7.5-7.5L14.125,5.312z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol